export function evaluateHighRollerRequirements({ venue, style, budget, price, available }) {
  if (!['usap', 'permitted', 'unsure'].includes(venue) || !['black-gold', 'open'].includes(style)) {
    return { state: 'incomplete', heading: 'Choose your requirements', text: 'Select your venue requirements and design preference to continue.' };
  }
  if (budget !== null && (!Number.isFinite(budget) || budget < 0)) {
    return { state: 'invalid-budget', heading: 'Check your budget', text: 'Enter a positive amount or leave the budget blank.' };
  }
  if (venue === 'usap') {
    return { state: 'approval', heading: 'Choose approved equipment for your event', text: 'High Roller is not USA Pickleball approved. Check the exact model on the official equipment list and confirm your event’s requirements.', showApproval: true };
  }
  if (venue === 'unsure') {
    return { state: 'venue', heading: 'Confirm your venue’s equipment rules first', text: 'Ask your venue or event organizer whether this paddle is permitted. High Roller is not USA Pickleball approved.', showApproval: true };
  }
  if (!Number.isFinite(price) || price < 0) {
    return { state: 'price', heading: 'Check the current product listing', text: 'The finder could not read a current price. Use the product page to confirm the option, price and availability.', showProduct: true };
  }
  if (budget !== null && budget < price) {
    return { state: 'budget', heading: 'High Roller is above your paddle budget', text: 'The currently displayed paddle price exceeds the amount you entered. Your full order may also include shipping and taxes.', showProduct: true };
  }
  if (!available) {
    return { state: 'unavailable', heading: 'Check back for current availability', text: 'The listed High Roller option is currently unavailable. You can still view its details and design photographs.', showProduct: true };
  }
  return { state: 'explore', heading: style === 'black-gold' ? 'Explore the High Roller look' : 'High Roller is one option to explore', text: 'Your venue and budget selections leave High Roller as an option. Compare the grip, fit and product details before deciding. Its metallic gold finish describes appearance.', showProduct: true };
}

export function createPaddleShortlistCsv({ title, price, currency, url }) {
  const cell = (value) => '"' + String(value ?? '').replace(/^[=+@\-]/, "'$&").replaceAll('"', '""') + '"';
  const rows = [
    ['Model', 'Manufacturer', 'Source URL', 'Price at download', 'Currency', 'USA Pickleball approved', 'Grip circumference', 'Handle length', 'Weight', 'Dimensions', 'Notes'],
    [title, 'Dope Pickleball', url, price, currency, 'No', '', '', '', '', 'Confirm venue rules and fit. Metallic gold finish describes appearance. Recheck current price and availability.'],
    ['', '', '', '', currency, '', '', '', '', '', 'Add another exact model and verify its source.'],
  ];
  return rows.map((row) => row.map(cell).join(',')).join('\r\n') + '\r\n';
}

function connectFinder(root) {
  if (root.dataset.connected === 'true') return;
  root.dataset.connected = 'true';
  const form = root.querySelector('form');
  const result = root.querySelector('[data-finder-result]');
  const heading = root.querySelector('[data-finder-heading]');
  const text = root.querySelector('[data-finder-text]');
  const productLink = root.querySelector('[data-finder-product]');
  const approvalLink = root.querySelector('[data-finder-approval]');
  const download = root.querySelector('[data-finder-download]');
  let measuredOutcome = '';
  if (!form || !result || !heading || !text || !productLink || !approvalLink || !download) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const fields = new FormData(form);
    const amount = fields.get('budget');
    const outcome = evaluateHighRollerRequirements({
      venue: fields.get('venue'), style: fields.get('style'),
      budget: amount === '' ? null : Math.round(Number(amount) * 100),
      price: root.dataset.price === '' ? NaN : Number(root.dataset.price),
      available: root.dataset.available === 'true',
    });
    heading.textContent = outcome.heading;
    text.textContent = outcome.text;
    productLink.hidden = !outcome.showProduct;
    approvalLink.hidden = !outcome.showApproval;
    result.dataset.state = outcome.state;
    result.hidden = false;
    heading.focus({ preventScroll: true });
    result.scrollIntoView({ behavior: 'auto', block: 'nearest' });
    if (outcome.state !== measuredOutcome && window.dopeClarityEvent?.('dope_finder_' + outcome.state)) measuredOutcome = outcome.state;
  });
  download.addEventListener('click', () => {
    const csv = createPaddleShortlistCsv({ title: root.dataset.title, price: root.dataset.priceLabel,
      currency: root.dataset.currency, url: root.dataset.productUrl });
    const url = URL.createObjectURL(new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8' }));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'pickleball-paddle-shortlist.csv';
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
}

function connectFinders() {
  document.querySelectorAll('[data-dope-paddle-finder]').forEach(connectFinder);
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectFinders, { once: true });
  else connectFinders();
  document.addEventListener('shopify:section:load', connectFinders);
}
